export default "/images/a1fa16e699c2c1309c180d012ecf868d.avif";